import { render, staticRenderFns } from "./SpecialtiesServices.vue?vue&type=template&id=7da19fb9&scoped=true"
import script from "./SpecialtiesServices.vue?vue&type=script&lang=js"
export * from "./SpecialtiesServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da19fb9",
  null
  
)

export default component.exports